import {createTheme, responsiveFontSizes} from '@mui/material/styles';
import Palette from './palette';
import {getTypography} from './typography';

let theme = createTheme({
  typography: palette => {
    return getTypography(palette);
  },
  palette: Palette
});
theme = responsiveFontSizes(theme);

export default theme;
